import React from 'react'
import { WhiteText, useAtSize } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { css } from '@emotion/core'
import { DocumentPdf, DocumentBasic } from '@fs/zion-icon'

const resourceStyle = css`
  border-radius: 12px;
  padding: 16px;
  background: var(--background-secondary);
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-column-gap: 16px;
  max-width: 400px;
  transition: background 0.05s;

  &:hover {
    background: var(--background-hover);
  }
`

const DownloadableResource = ({ href = '', title = 'Brochure' }) => {
  const atSize = useAtSize()
  const Icon = href.endsWith('.pdf') ? DocumentPdf : DocumentBasic
  return (
    <Link
      css={resourceStyle}
      data-testid="downloadable-resource-link"
      to={href}
      download={title}
      target="_blank"
      external
      noLinkStyles
    >
      <Icon size={atSize({ default: 'xs', xs: 'xs', sm: 'sm' })} color="#fff" />
      <WhiteText>{title}</WhiteText>
    </Link>
  )
}

export default DownloadableResource
